// store.ts
import { configureStore, Reducer } from '@reduxjs/toolkit';
import {
  createRootReducer,
  RootState,
  InjectableReducerKey,
  InjectedReducersMap,
} from './root-reducer';

const injectedReducers: InjectedReducersMap = {};

const store = configureStore({
  reducer: createRootReducer(),
});

export function injectReducer(
  key: InjectableReducerKey,
  reducer: Reducer,
): void {
  if (injectedReducers[key]) {
    return;
  }
  injectedReducers[key] = reducer;
  store.replaceReducer(createRootReducer(injectedReducers));
}

export type AppDispatch = typeof store.dispatch;
// If you want to re-export RootState from here as well:
export type { RootState };

export default store;
